import { render, staticRenderFns } from "./appStore.vue?vue&type=template&id=0474c3b9&"
import script from "./appStore.vue?vue&type=script&lang=js&"
export * from "./appStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports